// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 873 ? "3d47b92a" : chunkId) + "." + {"69":"31d0d3e7e25ea4e1","119":"4f573e6beedf116c","458":"6872e4c5d02e02f1","873":"e36554d57f5830a8"}[chunkId] + ".js";
};